/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
import { d as calciteContainerSizeWidthXxs, e as calciteContainerSizeWidthXs, f as calciteContainerSizeWidthSm, g as calciteContainerSizeWidthMd } from "./global.js";
const breakpoints = {
  width: {
    medium: cssLengthToNumber(calciteContainerSizeWidthMd.max),
    small: cssLengthToNumber(calciteContainerSizeWidthSm.max),
    xsmall: cssLengthToNumber(calciteContainerSizeWidthXs.max),
    xxsmall: cssLengthToNumber(calciteContainerSizeWidthXxs.max)
  }
};
function cssLengthToNumber(length) {
  return parseInt(length);
}
export {
  breakpoints as b
};
